const WEEKDAY_MAP = {
    sun: 0,
    mon: 1,
    tue: 2,
    wed: 3,
    thu: 4,
    fri: 5,
    sat: 6,
};
export function parseWeekdays(weekdaysString) {
    if (!weekdaysString || weekdaysString.trim() === '') {
        return [];
    }
    const validWeekdays = new Set(Object.keys(WEEKDAY_MAP));
    return weekdaysString
        .split(',')
        .map(day => day.trim().toLowerCase())
        .filter((day) => validWeekdays.has(day));
}
export function getNextMatchingWeekday(baseline, targetWeekdays) {
    if (targetWeekdays.length === 0) {
        throw new Error('targetWeekdays cannot be empty');
    }
    const targetDays = targetWeekdays.map(wd => WEEKDAY_MAP[wd]);
    const result = new Date(baseline);
    const currentDay = result.getUTCDay();
    let minDaysToAdd = 8;
    for (const targetDay of targetDays) {
        let daysToAdd = targetDay - currentDay;
        if (daysToAdd < 0) {
            daysToAdd += 7;
        }
        if (daysToAdd < minDaysToAdd) {
            minDaysToAdd = daysToAdd;
        }
    }
    result.setUTCDate(result.getUTCDate() + minDaysToAdd);
    return result;
}
export function calculateNextPublishDate(params) {
    const { showSlug, customPublishWeekdays, defaultPublishWeekdays, publishHour, latestPublishDate, todayStory } = params;
    const weekdaysString = customPublishWeekdays || defaultPublishWeekdays;
    const weekdays = parseWeekdays(weekdaysString);
    if (weekdays.length === 0) {
        throw new Error(`No weekdays configured for show: ${showSlug}`);
    }
    const todayStart = new Date();
    todayStart.setUTCHours(0, 0, 0, 0);
    const currentWeekday = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'][todayStart.getUTCDay()];
    const isTodayScheduled = weekdays.includes(currentWeekday);
    let baseline;
    if (isTodayScheduled && !todayStory) {
        baseline = todayStart;
    }
    else if (latestPublishDate) {
        const lastPublished = new Date(latestPublishDate);
        const dateEnd = new Date(lastPublished);
        dateEnd.setUTCHours(0, 0, 0, 0);
        dateEnd.setUTCDate(dateEnd.getUTCDate() + 1);
        baseline = new Date(Math.max(dateEnd.getTime(), todayStart.getTime()));
    }
    else {
        baseline = todayStart;
    }
    const nextDate = getNextMatchingWeekday(baseline, weekdays);
    nextDate.setUTCHours(publishHour, 0, 0, 0);
    return nextDate.toISOString();
}
//# sourceMappingURL=publishScheduling.js.map